import { StyleSheet } from 'react-native';
export const ModalStyles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
    },
    listArea: {
        flex: 1,
        flexDirection: 'row',
    },
    keyboardContainer: {
        flex: 1,
        flexDirection: 'row',
    },
});
//# sourceMappingURL=ModalStyles.js.map